import React, {useEffect, useContext} from 'react'
import CryptoJS from 'crypto-js'
import {useAuth} from '../auth'
import AppContext from '../../AppContext'
import {useParams, useNavigate} from 'react-router-dom'
import usePostApi from '../custom_hooks/usePostApi'
import {UseToast} from '../useToast'
import './index.css'

const SECRET_KEY = 'your-32-char-secret-key'

export function encrypt(text: string) {
  return CryptoJS.AES.encrypt(text, SECRET_KEY).toString()
}

const Subscriptions = () => {
  const {id} = useParams()
  const {execute, loading} = usePostApi()
  const {stripeCusId}: {stripeCusId: string} = useContext(AppContext)
  // console.log(stripeCusId, id)

  const {currentUser} = useAuth()

  const getStripeLink = async () => {
    try {
      const url = '/pod/billing/portal'
      const formData = {
        stripe_customer_id: stripeCusId,
        pod_code: id,
      }

      const response = await execute(url, 'POST', formData)
      if (response?.data?.url) {
        window.location.replace(response.data.url)
        // window.location.href = response.data.url
      }
    } catch (error: any) {
      console.error('Error:', error)
      UseToast(
        error.response?.data?.status_message,
        {
          position: 'bottom-right',
          theme: 'colored',
          autoClose: true,
        },
        'error'
      )
    }
  }

  useEffect(() => {
    getStripeLink()
  }, [])

  return (
    <div className='card h-200px d-flex flex-column justify-content-center align-items-center'>
      <div className='spinner-border spinner-primary mr-15 text-primary mb-2'></div>
      <p>Fetching your billing portal...</p>
    </div>
  )
}

export default Subscriptions

// useEffect(() => {
//   if (!document.querySelector('script[src="https://js.stripe.com/v3/pricing-table.js"]')) {
//     const script = document.createElement('script')
//     script.src = 'https://js.stripe.com/v3/pricing-table.js'
//     script.async = true
//     document.body.appendChild(script)
//   }
// }, [])

//  const raw = `${uuidv4()}-${currentUser?.user_id}-${podId}`
//   const encrypted = encrypt(raw)

//   return (
//     <div>
//       <PageTitle breadcrumbs={[]}>Subscriptions</PageTitle>
//       <stripe-pricing-table
//         pricing-table-id='prctbl_1S5nnHGLL0nc02eZ7LEcvesU'
//         // pricing-table-id='prctbl_1Rm6WCGLL0nc02eZjIwu0JDt'
//         publishable-key='pk_test_6BvhP8MDjJjV8oqA3370UK4q'
//         customer-id={stripeCusId}
//         client-reference-id={encrypted}
//         customer-email={currentUser?.email || undefined}
//       ></stripe-pricing-table>
//     </div>
//   )
